import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "container navbar-container" }
const _hoisted_3 = { class: "navbar-brand" }
const _hoisted_4 = ["data-target"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "navbar-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "navbar-logo"),
        _renderSlot(_ctx.$slots, "navbar-burger", {}, () => [
          _createElementVNode("a", {
            role: "button",
            class: _normalizeClass(["navbar-burger", { 'is-active': $setup.menuToggle }]),
            "aria-label": "menu",
            "aria-expanded": "false",
            "data-target": $props.name,
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.menuToggle = !$setup.menuToggle))
          }, _hoisted_8, 10, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", {
        id: $props.name,
        class: _normalizeClass(["navbar-menu mr-0", { 'is-active': $setup.menuToggle }])
      }, [
        _createElementVNode("div", _hoisted_10, [
          _renderSlot(_ctx.$slots, "navbar-items-left")
        ]),
        _renderSlot(_ctx.$slots, "navbar-items-right")
      ], 10, _hoisted_9)
    ])
  ]))
}